export const Variables = {
  UserInput: "UserInput",
  Event: "Event",
  UserName: "UserName",
  ContactPhone: "contact.phone",
  ContactName: "contact.Name",
  ContactEmail: "contact.email",
  ContactStatus: "contact.status",
  CallDuration: "call.duration",
  CallStatus: "call.status",
  CallSentiment: "call.sentiment",
};

export const NodeTypes = {
  Start: "START",
  OutboundCall: "OUTBOUND_CALL",
  SendSMS: "SEND_SMS",
  Delay: "DELAY",
  SendEmail: "SEND_EMAIL",
  HttpRequest: "HTTP_REQUEST",
  Conditional: "CONDITION",
  End: "END",
  // AI & Intelligence
  AiClassify: "AI_CLASSIFY",
  // Instagram
  SendInstagramMessage: "SEND_INSTAGRAM_MESSAGE",
  SendInstagramComment: "SEND_INSTAGRAM_COMMENT",
  // CRM & Data
  SyncLeadSquared: "SYNC_LEADSQUARED",
  UpdateContact: "UPDATE_CONTACT",
  TagContact: "TAG_CONTACT",
  CreateTask: "CREATE_TASK",
  // Journey Control
  WaitForEvent: "WAIT_FOR_EVENT",
  // Legacy WhatsApp nodes for backward compatibility
  Text: "text",
  SendMessage: "sendMessage",
  List: "list",
  QuickReply: "QuickReply",
  Image: "image",
  Video: "video",
  Document: "document",
};


export const Operators = {
  EqualsTo: "equals",
  NotEqualTo: "not_equals",
  Contains: "contains",
  NotContains: "not_contains",
  StartsWith: "starts_with",
  EndsWith: "ends_with",
  GreaterThan: "greater_than",
  LessThan: "less_than",
  IsEmpty: "is_empty",
  IsNotEmpty: "is_not_empty",
  IsTrue: "is_true",
  IsFalse: "is_false",
};

export const ConditionOperators = [
  { value: "equals", label: "Equals (==)" },
  { value: "not_equals", label: "Not Equals (!=)" },
  { value: "contains", label: "Contains" },
  { value: "not_contains", label: "Does Not Contain" },
  { value: "starts_with", label: "Starts With" },
  { value: "ends_with", label: "Ends With" },
  { value: "greater_than", label: "Greater Than (>)" },
  { value: "greater_or_equal", label: "Greater or Equal (>=)" },
  { value: "less_than", label: "Less Than (<)" },
  { value: "less_or_equal", label: "Less or Equal (<=)" },
  { value: "is_empty", label: "Is Empty" },
  { value: "is_not_empty", label: "Is Not Empty" },
  { value: "is_true", label: "Is True" },
  { value: "is_false", label: "Is False" },
];

export const ConditionTypes = {
  IF: "IF",
  ELSE: "ELSE",
  ELSE_IF: "ELSE_IF",
};

export const labels = {
  IF: "If",
  ELSE: "Else",
  ELSE_IF: "Else If",
  equals: "==",
  not_equals: "!=",
  contains: "contains",
  not_contains: "not contains",
  starts_with: "starts with",
  ends_with: "ends with",
  greater_than: ">",
  greater_or_equal: ">=",
  less_than: "<",
  less_or_equal: "<=",
  is_empty: "is empty",
  is_not_empty: "is not empty",
  is_true: "is true",
  is_false: "is false",
};

export const Conjunctions = {
  OR: "OR",
  AND: "AND",
};

export const generateId = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let uniqueString = "";
  for (let i = 0; i < 8; i++) {
    uniqueString += characters.charAt(
      Math.floor(Math.random() * characters.length)
    );
  }
  return uniqueString;
};

// Initial node setup with standard START node
export const initialNodes = [
  {
    id: "1",
    type: NodeTypes.Start,
    data: {
      nodeType: NodeTypes.Start,
      label: "Journey Trigger",
      config: {},
    },
    deletable: false,
    position: { x: 250, y: 120 },
  },
];
